import type { LinkProps as ChakraLinkProps } from "@chakra-ui/react";
import { chakra, Link } from "@chakra-ui/react";
import * as React from "react";
import { buttonRecipe } from "../../theme/recipes/button";

export interface LinkButtonProps extends ChakraLinkProps {}

export const LinkButton = chakra(function LinkButton(props) {
  const { children, ...rest } = props;
  return (
    <Link gap={1} alignItems={"center"} {...rest}>
      {children}
    </Link>
  );
}, buttonRecipe);
